import './main.less';
import PropTypes from 'prop-types';
import React from 'react';
import ModalBox from '../../../shared/modal';

const Form = props => {
	const { toggleFraudPopup } = props;
	return (
		<div className="payouts-transaction-form-wrap fraud-form-in-modal">
			<button
				className="ui-btn  ui-btn-cancel apply"
				onClick={async e => {
					e.preventDefault();
					await props.markAsFraud();
					toggleFraudPopup();
				}}
			>
				{props.intl('Yes')}
			</button>
			<button
				className="ui-btn ui-btn-cancel apply"
				onClick={async e => {
					e.preventDefault();
					toggleFraudPopup();
				}}
			>
				{props.intl('No')}
			</button>
		</div>
	);
};

Form.propTypes = {
	intl: PropTypes.func
};

const Main = props =>
	<ModalBox
		title={props.intl(
			`Отметить ${props.data.length} 
			конверсий от веба(ов) ${props.affiliatesFilterValues.join()} как фрод?`
		)}
		body={Form(props)}
		isOpen={props.isFraudPopupVisible}
		onClose={props.toggleFraudPopup}
		className="fraud-form-modal"
	/>;

Main.propTypes = {
	intl: PropTypes.func
};

export default Main;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/statistics/components/popups/mark-as-fraud.js